class TextLoopAnimation {
  constructor() {
    this.init();
  }


  init() {
    this.copyText();
    this.calculateLoopAnimationSpeed();
    this.resizeRefresh();
  }


  // リサイズ時にアニメーションの速度を再計算
  resizeRefresh() {
    const target = document.body;
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this.calculateLoopAnimationSpeed();
      });
    });
    resizeObserver.observe(target);
  }


  // アニメーションの速度を計算してCSS変数に
  calculateLoopAnimationSpeed() {
    const targets = document.querySelectorAll('[data-js="tick"]');
    if (!targets.length) {
      return;
    }


    const distance = window.innerWidth;
    const mql = window.matchMedia('(min-width: 768px)');
    const time = mql.matches ? 40 : 10;
    const speed = distance / time;


    targets.forEach((target) => {
      const tickElems = target.querySelectorAll('[data-js="tick-item"]');
      if (!tickElems.length) {
        return;
      }


      const total = tickElems.length - 1;


      // 寸法の読み取りを先に完了し、書き込みとの交互実行を避ける。
      const widths = [...tickElems].map(el => el.clientWidth);
      tickElems.forEach((el, i) => {
        const elWidth = widths[i];
        const elTime = Math.floor(elWidth / speed);
        el.style.setProperty('--tick-duration', `${elTime}s`);
        el.style.setProperty('--tick-delay', `${elTime / -2}s`);


        if (i === total) {
          el.parentNode.classList.remove('no-tick');
        }
      });
    });
  }


  // テキストをコピーする
  copyText() {
    const targets = document.querySelectorAll('[data-js="tick"]');
    if (!targets.length) {
      return;
    }


    targets.forEach((target) => {
      const tickElems = target.querySelectorAll('[data-js="tick-item"]');
      if (!tickElems.length) {
        return;
      }


      // 元要素の寸法をDOM挿入前にまとめて読む。複製数・順序は維持する。
      const widths = [...tickElems].map(el => el.clientWidth);
      let length = 0;
      tickElems.forEach((el, i) => {
        length += widths[i];
        el.insertAdjacentHTML('afterend', el.outerHTML);
        if (length > window.innerWidth) {
          return;
        }
      });
    });
  }
}


export default TextLoopAnimation
